import { Controller } from "stimulus";
import Rails from "@rails/ujs";

export default class extends Controller {
  //static targets = ["field", "newClient", "selectClientForm"];
  //static values = { id: Number, changed: Boolean, submittedValue: Boolean };
  static targets = ["promoForm", "batchSize", "givenQuantity", "orderableType", "orderableId"];


  initialize() { }

  submitForm(e) {
    this.lejeuTarget.dispatchEvent(
      new CustomEvent("submit", { bubbles: true })
    );
  }

  action_select(e) {
    console.log("ACTION SELECT");
    console.log(e.srcElement.value);
    console.log(e);
    this.submitForm(e);
  }

  item_select(e) {
    console.log("ITEM SELECT");
    var value = JSON.parse(e.srcElement.value);
    this.orderableTypeTarget.value = value.type;
    this.orderableIdTarget.value = value.id;
    console.log(e);
  }

}
